
import SourcesGround from './sources-ground.vue'
import Source from './source.vue'
import SourceWrap from './source-wrap.vue'
//TODO need to calculate width of column automaticaly
const __default__ = {
  components: {SourcesGround, Source, SourceWrap},
  props: {
    sources: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      show_all: false,
      overflow: true
    }
  },
  computed: {
    cols_cnt(){
      if (this.$responsive.mobile) return 2
      else return 4
    },
    cols_width(){
      if (!this.$responsive.mobile) return '17.4rem'
      return '1fr'
    },
    rest_items(){
      return this.sources.toSpliced(0, this.cols_cnt)
    },
  },
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "023da601-cols_cnt": (_ctx.cols_cnt),
  "023da601-cols_width": (_ctx.cols_width)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__